import { Order } from "src/shared/services/interfacev2";
import api from "../../../../../../features/auth/axiosConfig";
import { API_URLS } from "../../../../../../shared/components/Url";
import { PaymentData } from "../../types/order";
import { getLedgerByCustomerIdApi } from "src/business-types/laundry/modules/orders/order-display/api";

export const processPaymentRequest = async (orderid: string, order: Order, paymentData: PaymentData) => {
  const customerId = order?.orders?.[0]?.customerId;

  const ledgerRes = await getLedgerByCustomerIdApi(customerId);

  const currentOutstanding = ledgerRes?.data?.ledger?.totalOutstandingBalance || 0;

  const previousReceived = (order?.paymentHistory || []).reduce((sum, p) => sum + Number(p.receivedAmount || 0), 0);

  const newReceived = Number(paymentData.ReceivedAmount || 0);

  const totalReceived = previousReceived + newReceived;

  const finalAmount = Number(order?.orders?.[0]?.finalAmount || 0);

  const discount = Number(paymentData.discount || 0);

  const remaining = finalAmount - totalReceived - discount;

  const safeRemaining = remaining > 0 ? remaining : 0;

  // const newOutstanding = currentOutstanding + safeRemaining;

  const now = new Date();
  const localDate = now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0") + "-" + String(now.getDate()).padStart(2, "0");

  const selectedPaymentMethod = paymentData.paymentMethod || order?.paymentHistory?.[0]?.paymentMethod || "Cash";

  await api.patch(`${API_URLS.ORDER}/${orderid}`, {
    customerId,
    remainingAmount: safeRemaining.toFixed(2),
    finalAmount,
    paymentHistory: [
      {
        paymentMethod: selectedPaymentMethod,
        receivedAmount: paymentData.ReceivedAmount,
      },
    ],
    payments: {
      paymentMethod: selectedPaymentMethod,
      receivedAmount: paymentData.ReceivedAmount,
    },
    outstandingBalance: currentOutstanding,
    newOrderAmount: "0",
    date: localDate,
    time: now.toTimeString().split(" ")[0],
    // deliveryDate: formatDate(now),
    // deliveryTime: formatTime(now),
    orderStatus: "Delivered",
    orderDate: localDate,
    orderTime: now.toTimeString().split(" ")[0],
  });

  return remaining;
};
